import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';
import { Tables } from '../lib/database.types';

const QUERY_KEY = 'technologies';

export const useTechnologies = (options = {}) => {
  const { category = null, isPublished = null, language = 'fr' } = options;

  return useQuery({
    queryKey: [QUERY_KEY, { category, isPublished, language }],
    queryFn: async () => {
      let query = supabase
        .from(Tables.TECHNOLOGIES)
        .select('*')
        .order('name');

      if (category) {
        query = query.eq('category', category);
      }
      
      if (isPublished !== null) {
        query = query.eq('is_published', isPublished);
      }

      const { data, error } = await query;

      if (error) throw error;
      
      return data;
    },
  });
};

export const useCreateTechnology = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (technology) => {
      const { data, error } = await supabase
        .from(Tables.TECHNOLOGIES)
        .insert(technology)
        .select()
        .single();

      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
    },
  });
};

export const useUpdateTechnology = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, ...updates }) => {
      const { data, error } = await supabase
        .from(Tables.TECHNOLOGIES)
        .update(updates)
        .eq('id', id)
        .select()
        .single();

      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
    },
  });
};

export const useDeleteTechnology = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      const { error } = await supabase
        .from(Tables.TECHNOLOGIES)
        .delete()
        .eq('id', id);

      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
    },
  });
};

export default useTechnologies;
